import React, { Component } from 'react'
import './level-progression-report.scss'
import { ImageConstants } from '../../../../constants/constants'
import { getImageSource } from '../../../../utility/image-source'
import HomeworkApi from '../../../../apis/homework'

class LevelProgressionReport extends Component {
  state = {
    homework: {},
    homeworkLevel: 'level1',
    levels: [
      {
        title: 'Novice',
        students: []
      },
      {
        title: 'Proficient',
        students: []
      },
      {
        students: []
      },
      {
        title: 'Advance',
        students: []
      }
    ]
  }

  levelColors = {
    1: '#8B8BF6',
    2: '#FFBB7C',
    3: '#C4C4C4',
    4: '#80D2F4'
  }

  componentDidMount () {
    if (this.props.selectedItem) {
      this.setState({
        homework: this.props.selectedItem,
        homeworkLevel: this.getLevel(this.props.selectedItem)
      })
    }
    this.getLevelProgressionReport()
  }

  getLevel = homework => {
    const category = homework.category
    let homeworkLevel = 'level1'
    if (category === 'NOVICE') {
      homeworkLevel = 'level1'
    } else if (category === 'PROFICIENT') {
      homeworkLevel = 'level2'
    } else if (category === 'ADVANCED') {
      homeworkLevel = 'level4'
    }
    return homeworkLevel
  }

  getFromLevel = _ => {
    const {homeworkLevel} = this.state
    const levelIndex = homeworkLevel.substring(5)
    return levelIndex
  }

  getLevelProgressionReport (payload = {}) {
    if (this.props.selectedItem) {
      payload.homeworkId = this.props.selectedItem._id
    }

    this.setState({ isLoading: true })

    HomeworkApi.getLevelProgressionReport(payload)
      .then(response => {
        const { levels } = this.state
        if (response && Object.keys(response).length > 0) {
          Object.keys(response).forEach(key => {
            const levelList = response[key]
            if (levelList && levelList.length > 0) {
              levelList.forEach((level, index) => {
                console.log(key)
                const fromLevel = this.getFromLevel()
                if (key === 'level1') {
                  levels[0].students.push({
                    ...level,
                    fromLevel
                  })
                }
                if (key === 'level2') {
                  levels[1].students.push({
                    ...level,
                    fromLevel
                  })
                }
                if (key === 'level3') {
                  levels[2].students.push({
                    ...level,
                    fromLevel
                  })
                }
                if (key === 'level4') {
                  levels[3].students.push({
                    ...level,
                    fromLevel
                  })
                }
                // if (key === 'level5') {
                //     levels[4].students.push({
                //       ...level,
                //       fromLevel
                //     })
                // }
              })
            }
          })
        }
        this.setState({
          isLoading: false
        })
      })
      .catch(err => {})
  }

  renderIcons = index => {
    const { homeworkLevel } = this.state
    console.log(homeworkLevel)
    if(homeworkLevel) {
        let fromIndex = homeworkLevel.substring(5)
        console.log(fromIndex)
        fromIndex = parseInt(fromIndex) - 1
        console.log(fromIndex, index)
        if (fromIndex  === (index + 1)) {
            return (
                <img
                className='level-icon'
                src={getImageSource(ImageConstants.EQUAL_ICON)}
                />
            )
        }

        if (fromIndex < index) {
            return (
                <img
                className='level-icon'
                src={getImageSource(ImageConstants.UP_ARROW)}
                />
            )
        }
        if (fromIndex > index) {
            return (
            <img
                className='level-icon'
                src={getImageSource(ImageConstants.DOWN_ARROW)}
            />
            )
        }
        }
    return ''

  }

  renderLevelStudents = () => {
    return (
      <div id='table-scoll' className='table-responsive mt-8'>
        <table className='table cw-table mb-0 align-items-center custom-homework-table-1'>
          <thead>
            <tr>
              {this.state.levels && this.state.levels.length
                ? this.state.levels.map((item, index) => (
                    <th
                      className='th-radius homework-text text-center'
                      style={{ backgroundColor: this.levelColors[index + 1] }}
                    >
                      Level {index + 1}
                    </th>
                  ))
                : ''}
            </tr>
          </thead>
          <tbody className='bg-white'>
            <tr assName='mt-4'>
              {this.state.levels && this.state.levels.length
                ? this.state.levels?.map((item, index) => (
                    <td
                      className='students-column number-of-students'
                      align='center'
                    >
                      {item.students.length}
                    </td>
                  ))
                : ''}
            </tr>
          </tbody>
        </table>
      </div>
    )
  }

  renderStudents = () => {
    return (
      <div id='table-scoll' className='table-responsive mt-8'>
        <table className='table cw-table mb-0 align-items-center custom-homework-table-2'>
          <thead>
            <tr>
              {this.state.levels && this.state.levels.length
                ? this.state.levels.map((item, index) => (
                    <th
                      className='th-radius homework-text text-center'
                      style={{ backgroundColor: this.levelColors[index + 1] }}
                    >
                      Level {index + 1} {item.title ? `(${item.title})` : ''}
                    </th>
                  ))
                : ''}
            </tr>
          </thead>
          <tbody className='bg-white'>
            <tr assName='mt-4'>
              {this.state.levels && this.state.levels.length
                ? this.state.levels.map((item, lIndex) => (
                    <td className='students-column number-of-students'>
                      <div className='student-wrapper'>
                        {item.students && item.students.length
                          ? item.students.map((student, index) => (
                              <div className='student-card-wrapper'>
                                <div className='row student-card-container'>
                                  <div
                                    className='col-1 student-left'
                                    style={{
                                      backgroundColor: this.levelColors[
                                        student.fromLevel
                                      ]
                                    }}
                                  >
                                    {this.renderIcons(lIndex)}
                                  </div>
                                  <div className='col-10 student-right'>
                                    <div className='row'>
                                      <div className='col-4 my-auto'>
                                        <div className='student-image'>
                                          <img
                                            className='student-image'
                                            src={
                                              'https://countingwell-doubts-assets-dev.s3.ap-south-1.amazonaws.com/366a7097-1ebe-4fc7-9c02-15eb91b53d49-user%20image.png'
                                            }
                                          />
                                        </div>
                                      </div>
                                      <div className='col-8 my-auto'>
                                        <div className='student-name'>
                                          {student.user?.name}
                                        </div>
                                        <div className='roll-no'>
                                          Roll no- {student.user?.rollNumber}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))
                          : ''}
                      </div>
                    </td>
                  ))
                : ''}
            </tr>
          </tbody>
        </table>
      </div>
    )
  }

  renderBreadcrumb = () => {
    return (
      <div className='breadcrumb'>
        <span>{'7th >'}</span>
        <span className='pl-2'>{'A >'}</span>
        <span className='pl-2'>{'Knowing Our Numbers >'}</span>
        <span className='active pl-2'>{'25th April'}</span>
      </div>
    )
  }

  onClickBack = () => {
    this.props.delegate &&
      this.props.delegate.hideReport &&
      this.props.delegate.hideReport()
  }

  render () {
    return (
      <div className='homework-progression-report'>
        <div className='mb-5'>
          <img
            className='back-icon cursor-pointer'
            src={getImageSource(ImageConstants.BACK_ICON)}
            onClick={() => this.onClickBack()}
          />
        </div>

        <span className='screen-title'>Level Progression Report</span>
        <span>{this.renderBreadcrumb()}</span>

        <div className='sub-title mt-5'>RHS congruence Criteria</div>

        {this.renderLevelStudents()}

        <div className='mt-5'>{this.renderStudents()}</div>
      </div>
    )
  }
}

export default LevelProgressionReport
